export enum PluginIndentifierEnum {
    WHATSAPP_BOT = 'WHATSAPP_BOT',
    PUBLIC_API = 'PUBLIC_API',
    GRIDWALL = 'GRIDWALL',
    // PROCORE = 'PROCORE',
    GOOGLE_SSO = 'GOOGLE_SSO',
    MICROSOFT_SSO = 'MICROSOFT_SSO',
    AUTODESK_SSO = 'AUTODESK_SSO',
    // ACONEX = 'ACONEX',
}

export enum PluginCameraIndentifierEnum {
    AI = 'AI',
    // BIM = 'BIM',
}
